import { atom } from 'jotai';

export const appAtom = atom<{
  platform: 'desktop' | 'ios' | 'android';
}>({
  platform: 'desktop',
});

export const loginModalAtom = atom<boolean>(false);
